<template>
  <div>
    <Hero/>
    <Billboard/>
    <Releases/>
    <Snacks/>
    <Promotions/>
    <Contact/>
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue';
import Billboard from '@/components/Billboard.vue';
import Releases from '@/components/Releases.vue';
import Snacks from '@/components/Snacks.vue';
import Promotions from '@/components/Promotions.vue';
import Contact from '@/components/Contact.vue';

export default {
  name: 'Home',
  components: {
    Hero,
    Billboard,
    Releases,
    Snacks,
    Promotions,
    Contact,
  },
};
</script>

